module.exports = __webpack_public_path__ + "img/spoutnik.037d9f9f.svg";